<script>
import $ from 'jquery';
import 'imarc-boilerplate/js/accordion.plugin.js';

export default {
    render() {
        return this.$scopedSlots.default();
    },

    mounted() {
        $(this.$el).accordion({ singleOpen: false });
    },
};
</script>
